import axios from 'axios';

export default {
  getAll(applicationId = '') {
    const parameters = applicationId ? { application_id: applicationId } : {};

    return axios.get('/rejection-reasons', { params: parameters });
  },
};
